<div fxLayout="row" fxLayoutAlign="space-evenly center" class="container">
  <button mat-button color="primary" (click)="gotIt()">Got It</button>
</div>
